import React from 'react';
import { FadeIn } from './FadeIn';
export function ProofSection() {
  return <section className="bg-bakery-brown text-bakery-cream py-24 px-6 relative overflow-hidden" data-id="element-137">
      {/* Subtle background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-bakery-amber/10 rounded-full blur-3xl pointer-events-none" data-id="element-138"></div>

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-139">
        <FadeIn data-id="element-140">
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-bakery-amber mb-8" data-id="element-141">
            Lo que cambia en 120 minutos
          </h2>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-142">
          <p className="text-2xl md:text-3xl font-serif italic leading-relaxed mb-8" data-id="element-143">
            "Hoy mismo podrías estar cortando una hogaza crujiente o mordiendo
            un Golfeado meloso que se deshace en tu boca."
          </p>
        </FadeIn>

        <FadeIn delay={0.4} data-id="element-144">
          <p className="text-xl text-bakery-tan font-medium uppercase tracking-widest" data-id="element-145">
            Tu mesa nunca volverá a estar vacía.
          </p>
        </FadeIn>
      </div>
    </section>;
}